export function barcodeCompare (a, b) {
  const acode = (a.config.logistics || {}).barcode
  const bcode = (b.config.logistics || {}).barcode
  if (acode !== bcode) {
    return acode.localeCompare(bcode, 'en', { numeric: true })
  }
  return a.id.localeCompare(b.id, 'en')
}
